import TYPES, { CLEAR_ADD_PROJECT_SUCCESS } from "./types";
import { axiosInstance, tokenConfig } from "../../../axiosInstance";
import { returnErrors, clearErrors } from "../../../actions/errorActions";
import API from "../API";

const {
  GET_CONTESTS_LOADING,
  GET_CONTESTS_SUCCESS,
  GET_CONTESTS_FAIL,

  GET_PROJECT_BY_ID_LOADING,
  GET_PROJECT_BY_ID_SUCCESS,
  GET_PROJECT_BY_ID_FAIL,
} = TYPES;

// Get Contests

export function getContests(user_id = null, id = null, page = null, limit = null, min_price = null,  max_price = null, cat_id = null, sub_cat_id = null, keywords = null, locale) {
  return async function getContestsWithDispatch(dispatch, getState){
    dispatch(clearErrors());
    dispatch({
      type: GET_CONTESTS_LOADING
    });
    try {
        let response = await axiosInstance
        .get(API.CONTESTS, {params: { id, user_id, min_price, max_price, cat_id, sub_cat_id, keywords, limit, page } , ...tokenConfig(getState, locale)});
        if(response.status !== 200){
            dispatch({
              type: GET_CONTESTS_FAIL,
            });
            throw Error({
                response: {
                    data: "Other Errors",
                    status: "Other Errors"
                },
            })
        }else{
            dispatch({
              type: GET_CONTESTS_SUCCESS,
              payload: response.data
            })
        }
    } catch (error) {
        if (error.response && error.response.data) {
          dispatch({
            type: GET_CONTESTS_FAIL
          });
          dispatch(returnErrors(error.response.data, error.response.status, 'GET_CONTESTS_FAIL'));
        }else{
          let errorJson = JSON.stringify(error);
          let errorParsed = JSON.parse(errorJson);
          dispatch({
            type: GET_CONTESTS_FAIL
          });
          dispatch(returnErrors(errorParsed.message, "Network Error", 'GET_CONTESTS_FAIL'));
        }
    }
  }
}

const exportedObject = {
  getContests,
};

export default exportedObject;
